// Services
import puppyPackService from "@/app/services/main/puppy-pack/puppy-pack-service.js";

// Components
const ProductModal = () =>
    import(
        /* webpackPrefetch: true, webpackChunkName: "file-upload" */ "@/app/views/main-view/products/containers/modals/product-item-modal/product-item-modal.vue"
    );

// Constants
import { STATUS_CODES } from "@/app/constants/status-constants";

export default {
    name: "DoggyPacksDetailsPage",
    components: { ProductModal },
    data() {
        return {
            isAPILoading: false,
            productDetails: {},
            includedProducts: [],
        };
    },
    computed: {
        saveAmount() {
            const {
                onSale,
                price: originalPrice,
                salePrice,
            } = this.productDetails;

            const productsSum = this.includedProducts.reduce(
                (sum, product) => sum + (parseFloat(product.price) * product.quantity),
                0
            );

            return onSale
                ? (productsSum - parseFloat(salePrice)).toFixed(2)
                : (productsSum - parseFloat(originalPrice)).toFixed(2);
        },
    },
    async created() {
        await this.getPuppyPackDetails();
    },
    methods: {
        async getPuppyPackDetails() {
            try {
                this.isAPILoading = true;
                const response = await puppyPackService.getPuppyPackDetails(
                    this.$route.params.id
                );

                if (response.status === STATUS_CODES.SUCCESS) {
                    const { bundle, products } = response.data;
                    this.includedProducts = products;
                    this.productDetails = bundle;

                    this.isAPILoading = false;
                }
            } catch (error) {
                this.isAPILoading = false;
            }
        },
        hasProductImage(productImage) {
            let image = require("@/assets/images/_shared/dog-purchase.png");

            if (productImage) {
                image = productImage;
            }

            return image;
        },
        replacePetName(description) {
            if (description) {
                return description.replace(
                    new RegExp("PET_NAME", "gi"),
                    "your dog"
                );
            }
        },
        showDescriptionModal(title, description, imageUrl) {
            let primaryImg = imageUrl;

            if (imageUrl) {
                primaryImg = this.productDetails.imageUrl
                    ? this.productDetails.imageUrl
                    : require("@/assets/images/product/dog-default-picture-color.png");
            }

            this.$swal({
                imageHeight: "50px",
                imageUrl: primaryImg,
                imageAlt: "description-img",
                title: `<strong>${title}</strong>`,
                text: this.replacePetName(description),
                confirmButtonText: "Close",
            });
        },
    },
};
